export default __webpack_public_path__ + "static/media/MaintenaceIcon.27c94039.svg";